module.exports = __webpack_public_path__ + "static/media/tac-logo-notxt.5138b3cb.svg";